
import { defineComponent, computed, watch, ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import vuex from '@/store'
import { PollingAuth, SystemMessage } from '@/Tool/LoginSet'
import { ElConfigProvider, ElButton } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import en from 'element-plus/lib/locale/lang/en'
import api from '@/services'
import { $t as lang } from '@/Tool'
import DeleteAccountModal from './components/DeleteAccountModal.vue'
import DeleteConfirmModal from './components/DeleteConfirmModal.vue'

export default defineComponent({
  setup() {
    const show = ref(true)
    const currentRole = ref()
    const days = ref(14)
    const detectStatus = computed(() => vuex.state.detectStatus)
    const detectDeadline = computed(() => vuex.state.detectDeadline)
    const showDetectAccountModal = computed(() => vuex.state.showDetectAccountModal)
    const showConfirmDeleteModal = computed(() => vuex.state.showConfirmDetectModal)
    const orgid = computed(() => vuex.state.user?.orgid)
    const userInfo = computed(() => vuex.state.user?.info)

    const chromeLang = localStorage.getItem('lang') || navigator.language.substr(0, 2)
    const locale = ref({})
    if (chromeLang === 'zh') {
      locale.value = zhCn
    } else if (chromeLang === 'en') {
      locale.value = en
    }
    const store = useStore()
    const username = computed(() => store.state.user?.info?.username).value
    const systemMessage = new SystemMessage({
      time: 100000,
    })
    const queryDetectStatus = async () => {
      const { data, success } = await api.Scrm_sys_api.srcmLogin.getUserTypes({})
      if (success) {
        const { user } = JSON.parse(sessionStorage.__user || '{}')
        currentRole.value = data.find((item) => item.type === user.orgid)

        vuex.commit('set_data', {
          detectStatus: currentRole.value?.destroyId > 0 ? 1 : 0,
          detectDeadline: currentRole.value?.destroyTime?.slice(0, 10) || '',
        })
      }
    }

    const handleConfirmDetect = () => {
      updateState('showConfirmDetectModal', false)
      queryDetectStatus()
    }

    const handleConfirm = () => {
      updateState('showDetectAccountModal', false)
      updateState('showConfirmDetectModal', true)
    }

    const handleUndoDetect = () => {
      vuex.commit('set_data', {
        showDetectAccountModal: false,
        showConfirmDetectModal: false,
      })
      queryDetectStatus()
    }

    const updateState = (st, value) => {
      vuex.commit('set_data', {
        [st]: value,
      })
    }

    watchEffect(() => {
      if (userInfo.value) {
        api.ConfigServer.checkWhiteList({
          dictName: '小视频',
          childDictNameList: ['cancelTime'],
        }).then(({ success, data }) => {
          if (success) {
            const value = data.childOption.find((item) => 'cancelTime' === item.optionName)
            if (value) {
              days.value = value.optionValue
            }
          }
        })
        queryDetectStatus()
      }
    })

    watch(
      () => orgid.value,
      (id: any) => {
        const pollingAuth = new PollingAuth({ orgid: id as number })
        if (id) {
          pollingAuth.start()
          systemMessage.start(vuex.state?.user?.info?.userId)
        } else {
          pollingAuth?.stop()
          systemMessage.stop()
        }
      },
      {
        immediate: true,
      },
    )
    return {
      locale,
      lang,
      username,
      show,
      days,
      detectDeadline,
      currentRole,
      detectStatus,
      updateState,
      handleConfirm,
      handleUndoDetect,
      handleConfirmDetect,
      showConfirmDeleteModal,
      showDetectAccountModal,
    }
  },
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    ElButton,
    DeleteAccountModal,
    DeleteConfirmModal,
  },
})
